<template>
    <AdminTrack75Liquidation></AdminTrack75Liquidation>
</template>
<script>
    import AdminTrack75Liquidation from '@/components/AdminTrackApproved75Liquidation.vue'
    export default {
        name: 'admin-track-approved-liquidation',
        components: {
            AdminTrack75Liquidation
        }
    }
</script>